var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-res"}},[_c('div',{attrs:{"id":"col1"}},[_c('the-filter')],1),_c('div',{attrs:{"id":"col2"}},[(_vm.loading)?_c('the-container'):_c('skeleton-loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }